import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Util } from "../util/util";

@Component({
    template: ''
})
export abstract class AbstractCrudComponent implements OnInit {

    data: any = [];

    dataSource: MatTableDataSource<any>;

    pageSize = 25;

    textFilter: string = '';

    @ViewChild(MatPaginator) paginator: MatPaginator | any;
    @ViewChild(MatSort) sort: MatSort | any;

    constructor(protected router: Router, protected dialog: MatDialog) {

        this.dataSource = new MatTableDataSource<any>([]);

    }

    ngOnInit() {
        this.configureTotalPorPagina(window.innerHeight);
    }

    doFilter = (event: any) => {
        if (event && event.target && event.target.value) {
            this.textFilter = event.target.value.trim().toLocaleLowerCase();
            this.dataSource.filter = this.textFilter;
        } else {
            this.textFilter = '';
            this.dataSource.filter = this.textFilter;
        }
    }

    doFilterOnLoad(): void {
        if (this.textFilter) {
            this.dataSource.filter = this.textFilter;
        } else {
            this.dataSource.filter = '';
        }
    }

    onResize(event: any) {

        this.configureTotalPorPagina(event.target.innerHeight);

    }

    configureTotalPorPagina(innerHeight: any): void {
        if (innerHeight <= 800) {

            this.pageSize = 10;

        } else if (innerHeight > 800 && innerHeight <= 1000) {

            this.pageSize = 30;

        } else if (innerHeight > 1000 && innerHeight <= 1200) {

            this.pageSize = 50;

        } else {

            this.pageSize = 70;

        }

        this.configurarDataSource();
    }

    configurarDataSource(): void {
        this.dataSource = new MatTableDataSource<any>(this.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    mascaraFoneCustom(fone: string): [string, any] {

        return Util.mascaraFoneCustom(fone);

    }
}
